<template>
  <div
    class="plain-route-viewport"
    :class="{
      'plain-route-viewport--module': presentation.framed,
      'plain-route-viewport--bare': !presentation.framed,
    }"
    :data-ui-route="presentation.name"
    :data-ui-route-group="presentation.group"
    :data-ui-route-kind="presentation.kind"
  >
    <slot />
  </div>
</template>

<script>
import { computed } from "vue";
import routePresentation from "@/ui/templates/plain-admin/route-presentation";

export default {
  name: "PlainAdminRouteViewport",
  props: {
    route: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const presentation = computed(() => routePresentation(props.route));
    return { presentation };
  },
};
</script>
